import type { FaireProductEntity } from "../../entity_types/product";

export const p_3u3anvm8g8: FaireProductEntity = {
  token: "p_3u3anvm8g8",
  type: "product",
  name: "Sailor Top (2XS/S - 2M/L)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/43805bd722205df17d91e3ded6e94fe3220e0bd606bacb47db75c66fdb4cd3c5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bb5f07f1da085834d48ce312b60d0ec20cfc36d8a869b8522b39da438d6ee802.jpeg",
    "https://cdn.faire.com/fastly/dc8662444f20b77870f389e379cc0da471f33dc2b08525f035fbd7dc57010348.jpeg",
    "https://cdn.faire.com/fastly/db0d17c34a5a0f3ced91fd916971e7ba700b221d0acd5bd6653bc58e0938acca.jpeg",
    "https://cdn.faire.com/fastly/bb3cb030f142a802322b8258dee935a5fdeb886746f3cdce32af134827dec4b4.jpeg",
    "https://cdn.faire.com/fastly/8db12822ae6986e955602745415b1a012f0891749b99beb6f2d72df5a44f0b8c.jpeg",
    "https://cdn.faire.com/fastly/20a9eb4dee14cc84d8d10c79c7caf09d621413d7b7753cab4a0cda1d28aefce0.jpeg",
    "https://cdn.faire.com/fastly/eb3e25a44b87adf3777ca41fd84d9133d4b3f3b5c2912fd38cecd30fa1192fff.jpeg",
    "https://cdn.faire.com/fastly/e2ed7963e99c1c96fe08f0dd952c2cdc5b34b6e0a175e30b2034d9ff3448dc3b.jpeg",
    "https://cdn.faire.com/fastly/2994092f97af8dd27f72b6d19fa13a65654107aa7fe4ffeb571a4bc575bd0cac.jpeg",
    "https://cdn.faire.com/fastly/47366a92141b35a00a1bded097c2dd4118cab81c4886849723ebd13abb32406b.jpeg",
    "https://cdn.faire.com/fastly/eaa7612243c135c0960c0c6ac2730f55b3f5dd1d6f6f3341783e41741ababc05.jpeg",
    "https://cdn.faire.com/fastly/4a712b02a2c8a17371b9c47455a8d5de0fd79367cc839e35b23a90d139cb57be.jpeg",
    "https://cdn.faire.com/fastly/6a5983c340c265e78f8a1aabdaeb4f6935305d7b58c223d2aaaf8ddcd1515545.jpeg",
    "https://cdn.faire.com/fastly/2422592467165e3600d341ae0c7a03b291ba516043686eef653f8a1a7ebd82f5.jpeg",
    "https://cdn.faire.com/fastly/b069e9cfa1bb53159a8769e1a3482014d31b497c5a50a551d5bb7ce1f8ce1549.jpeg",
    "https://cdn.faire.com/fastly/ca95d078beca50044cef1ef967727a61bf05d850f93b4b9fa38467714253b26a.jpeg",
    "https://cdn.faire.com/fastly/1b848e8f9bf351ec0087a64329b87a27d31f7f6adb39b7e8d520cb1d1ab622c3.jpeg",
    "https://cdn.faire.com/fastly/ef0269076dcb4b033ca3e19691d00bb90570e105a08d07d24923fa5f604f1fab.jpeg",
    "https://cdn.faire.com/fastly/1379dbe175aff753f5c8a6aef319f3271b8b8351d766ec0eece73cc182be18cf.jpeg",
    "https://cdn.faire.com/fastly/9ec50940fc5b408e7e791a8aa2cdf24f0b8cc3be9095e35f65abaeb6f01dc8dc.jpeg",
    "https://cdn.faire.com/fastly/a7f74bf81ba2e0562824e5147ada67404370aa4a05f03463e19aff8a746227fd.jpeg",
    "https://cdn.faire.com/fastly/700e6cd6ac04b5acc5359a75624fe83f130a93e18fe66134bbb5222612eeb8b3.jpeg",
    "https://cdn.faire.com/fastly/7841e82cb9f1b1cfd9d7c0d9f4d6b4d5b00b2f67facd480f74a03c76459ba6c1.jpeg",
    "https://cdn.faire.com/fastly/15de184cd7ce678ebcfc6df42b9d524a5edd245abf523cbf90363591b1bfa445.jpeg",
  ],
  priceDollars: 192,
  description:
    'Why We Made This?\n\nA nautical long sleeve with a classic fit. The Sailor Top takes design cues from the Marseille Top, featuring a Breton stripe and boxy shape, but updated with a flattering round neckline and a slightly cropped length that pairs effortlessly with high-waisted bottoms.\n\n\n\nContents: \n\n100% Cotton Heavy Cotton Stripe\n\n\n\nCare Instructions:\n\n-Machine wash cold with like colors\n-Do not soak\n-Do not spot clean\n-Hang dry for best results or tumble dry on low heat\n\n\n\n\nApproximate Measurements: \n\n\nXS/S : Chest 21", Length 22"\n\n\nM/L : Chest 22 1/2", Length 22 1/2"\n\n\n\nModel is 5\' 6", Bust: 34", Waist: 27", Hip:36" and wearing a size XS/S\n\n\n\nMade in South Korea \n\n\n\nMSRP: $95 USD\n\n\n\n\n\n',
  tags: [],
  msrpDollars: 380,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:52:06.821Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
